// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","header":"App_header__2L3DO","content":"App_content__1Wt3K","footer":"App_footer__3csul","container":"App_container__eSJ6i"};